import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { AccountsService } from "../api";

import { accountsListActions } from "./accountsList";
import { toastActions } from "./toast";

interface DeleteAccountState {
  id: number | undefined;
  corporateName: string | undefined;
  isPopupShow: boolean;
}

interface RootState {
  deleteAccount: DeleteAccountState;
}

interface ThunkAPI {
  getState: () => RootState;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  dispatch: (value: unknown) => unknown;
}

const doDeleteAccount = createAsyncThunk(
  "doDeleteAccount",
  async (id: number, thunkAPI: ThunkAPI) => {
    const { corporateName } = thunkAPI.getState().deleteAccount;
    const res = await AccountsService.accountsDestroy({ id });
    thunkAPI.dispatch(deleteAccountActions.setInitState());
    if (!res.success) {
      thunkAPI.dispatch(toastActions.toastError(res.message));
      return;
    }

    thunkAPI.dispatch(
      toastActions.toastSuccess(
        `アカウント（ ${corporateName} ）が削除されました。`,
      ),
    );
    thunkAPI.dispatch(accountsListActions.fetchAccounts());
  },
);

const initialState: DeleteAccountState = {
  id: undefined,
  corporateName: undefined,
  isPopupShow: false,
};

const deleteAccountSlice = createSlice({
  name: "deleteAccount",
  initialState,
  reducers: {
    setId: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
    },
    setCorporateName: (state, action: PayloadAction<string>) => {
      state.corporateName = action.payload;
    },
    setIsPopupShow: (state, action: PayloadAction<boolean>) => {
      state.isPopupShow = action.payload;
    },
    setDeleteAccount: (
      state,
      action: PayloadAction<Partial<DeleteAccountState>>,
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setInitState: () => {
      return initialState;
    },
  },
});

const deleteAccountActions = {
  ...deleteAccountSlice.actions,
  doDeleteAccount,
};
export { deleteAccountActions };
export default deleteAccountSlice.reducer;
